import { Base } from "../core/base.model";
import { Etapa } from "../gestion-proyectos/etapa/etapa";

export class Proyectos extends Base {
id: number;
nombre: string;
nombreProyCorto: String;
descripcionProy: String;
incidencias: String;
incidenciasCu: String;
idCliente: String;
cliente: String;
color: String;
etapas: Etapa[] =[];

}